var map = {
	"./IndexReviewCarousel/denisa-gafova.jpg": 8022,
	"./IndexReviewCarousel/jan-svoboda.jpg": 36785,
	"./IndexReviewCarousel/kamila-pilna.jpg": 98216,
	"./IndexReviewCarousel/karel-antos.jpg": 85368,
	"./IndexReviewCarousel/lada-kosova.jpg": 58144,
	"./IndexReviewCarousel/petr-jaros.jpg": 84648,
	"./about/goodcall.jpg": 97914,
	"./baseCounter/blue.jpg": 44238,
	"./baseCounter/brown.jpg": 38054,
	"./baseCounter/orange.jpg": 45106,
	"./baseCounter/pink.jpg": 99424,
	"./instructors/adam-libra.jpg": 52242,
	"./instructors/ondrej-hanus.jpg": 5693,
	"./instructors/petr-jaros.jpg": 70661,
	"./lectures/Bitmap.jpg": 6270,
	"./lectures/lecturesCards/image/goodcall.jpg": 19778,
	"./lectures/pageHeader/header-hd.jpg": 46976,
	"./lectures/pageHeader/header-lg.jpg": 44882,
	"./lectures/pageHeader/header-xxl.jpg": 8750,
	"./lectures/pageHeader/header.jpg": 24513,
	"./microsoft365/microsoft365About/cyber-security.jpg": 57810,
	"./microsoft365/microsoft365About/microsoft-365.jpg": 67611,
	"./microsoft365/microsoft365About/microsoft-azure.jpg": 44713,
	"./microsoft365/microsoft365About/power-automate.jpg": 85867,
	"./microsoft365/microsoft365About/power-bi.jpg": 52997,
	"./microsoft365/microsoft365About/students.jpg": 82881,
	"./microsoft365/microsoft365More/cyber-security.jpg": 93309,
	"./microsoft365/microsoft365More/microsoft-365.jpg": 71219,
	"./microsoft365/microsoft365More/microsoft-azure.jpg": 18843,
	"./microsoft365/microsoft365More/power-automate.jpg": 56627,
	"./microsoft365/microsoft365More/power-bi.jpg": 22470,
	"./microsoft365/pageHeader/header-hd.jpg": 77882,
	"./microsoft365/pageHeader/header-lg.jpg": 49023,
	"./microsoft365/pageHeader/header-xxl.jpg": 72594,
	"./microsoft365/pageHeader/header.jpg": 80178,
	"./popup/bezpecnost2024_1.jpg": 97457,
	"./students/pageHeader/header-hd.jpg": 70762,
	"./students/pageHeader/header-lg.jpg": 97872,
	"./students/pageHeader/header-xxl.jpg": 46540,
	"./students/pageHeader/header.jpg": 9276,
	"./studyProgram/pageHeader/header-hd.jpg": 86912,
	"./studyProgram/pageHeader/header-lg.jpg": 99039,
	"./studyProgram/pageHeader/header-xxl.jpg": 30626,
	"./studyProgram/pageHeader/header.jpg": 85887
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1810;